<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title fxFlex="50">
      <span>{{title | translation:CLOSURES}}</span>
    </mat-panel-title>
    <mat-panel-description>
      <span i18n>{total, plural, =0 {empty} =1 {1 closure} other {{{total}} closures}}</span>
      <mat-error *ngIf="error">
        <mat-icon>error</mat-icon>
      </mat-error>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <ng-content></ng-content>

</mat-expansion-panel>
